import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { RollApplication, RollMaterial } from "../models/RollApplication";

export const getRollApplications = async ({
	id = null,
}: {
	id?: number | null;
} = {}): Promise<RollApplication[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "OnlyActives", value: false }];

	if (id) {
		parameters.push({ name: "Id", value: id });
	}

	const resp = await apiService.callV2(
		"[ROLLS].[GetRollApplications]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as RollApplication[];
	}
	throw new Error(resp.message || "Error fetching roll applications");
};

export const upsertRollApplication = async (
	app: RollApplication,
): Promise<RollApplication> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Id", value: app.Id },
		{ name: "Name", value: app.Name || "-" },
		{ name: "RollMaterialId", value: app.RollMaterialId ?? -1 },
		{ name: "MaximumHardness", value: app.MaximumHardness ?? -1 },
		{ name: "MinimumHardness", value: app.MinimumHardness ?? -1 },
		{ name: "ApplicationComments", value: app.ApplicationComments || "-" },
		{ name: "C", value: app.C ?? -1 },
		{ name: "Mn", value: app.Mn ?? -1 },
		{ name: "P", value: app.P ?? -1 },
		{ name: "S", value: app.S ?? -1 },
		{ name: "Si", value: app.Si ?? -1 },
		{ name: "Cr", value: app.Cr ?? -1 },
		{ name: "Ni", value: app.Ni ?? -1 },
		{ name: "Mo", value: app.Mo ?? -1 },
		{ name: "Mg", value: app.Mg ?? -1 },
		{ name: "Co", value: app.Co ?? -1 },
		{ name: "Va", value: app.Va ?? -1 },
		{ name: "W", value: app.W ?? -1 },
		{ name: "Al", value: app.Al ?? -1 },
		{ name: "V", value: app.V ?? -1 },
		{ name: "Cu", value: app.Cu ?? -1 },
		{ name: "Active", value: app.Active },
	];

	const resp = await apiService.callV2(
		"[ROLLS].[UpsertRollApplication]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows[0]", null) as RollApplication;
	}
	throw new Error(resp.message || "Error saving roll application");
};

export const removeRollApplication = async (id: number): Promise<void> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "Id", value: id }];

	const resp = await apiService.callV2(
		"[ROLLS].[RemoveRollApplication]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting roll application");
	}
};

export const getRollMaterials = async (): Promise<RollMaterial[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "OnlyActives", value: true }];

	const resp = await apiService.callV2(
		"[ROLLS].[GetRollMaterials]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as RollMaterial[];
	}
	throw new Error(resp.message || "Error fetching roll materials");
};
